import Router from "next/router";
import { LOGIN, Routes } from "../../routes/RouteConstants";
import { STORAGE_ITEMS } from "../constants";
import CookieService from "../CookieService";

const AUTH_ROUTES = [
  Routes.VERIFY_EMAIL,
  Routes.CANDIDATE_LISTING,
  Routes.CLIENT_DETAILS,
  Routes.CONTACT_DETAILS,
  Routes.DOCUMENT_VERIFICATION,
  Routes.EMAIL_VERIFICATION,
  Routes.IRRELEVANT,
  Routes.DASHBOARD,
  // Routes.JOB_POSTING_FORM,
  Routes.PROFILE,
  Routes.CHECKOUT,
  Routes.PLAN_SELECTION,
  Routes.TRANSACTION_STATUS,
  Routes.TRANSACTION_HISTORY,
  Routes.JOB_PLAN_SELECTION,
  Routes.SELECT_JOB_PLAN,
  Routes.LANDING_PAGE,
  Routes.HELP_CENTRE,
  Routes.DATABASE_PRODUCT,
  Routes.JOB_ADD_QUESTIONS,
  Routes.TEAMS,
  Routes.OVERVIEW,
  Routes.TEAMS_LOGS,
  Routes.TEAM_JOINING_FORM,
  Routes.WELCOME,
  Routes.WA_BROADCAST_CANDIDATE_SELECTION,
  Routes.CREATE_BROADCAST,
  Routes.VIEW_BROADCASTS,
  Routes.WHATSAPP_BROADCAST,
  Routes.DOWNLOAD_CANDIDATES_CMP,
  Routes.DOWNLOAD_CANDIDATES_DATABASE,
  Routes.BULK_UNLOCK_DATABASE,
  Routes.BULK_UNLOCK_CMP,
  Routes.STANDALONE_DATABASE
];

const CHECK_PROFILE = [
  Routes.VERIFY_EMAIL,
  Routes.DASHBOARD,
  Routes.EMAIL_VERIFICATION,
  Routes.DOCUMENT_VERIFICATION,
  Routes.PROFILE,
  Routes.OVERVIEW,
  Routes.SELECT_JOB_PLAN
];

const IGNORE_CREDIT_PROFILE = [Routes.CANDIDATE_LISTING, Routes.PROFILE];

const UserService = {
  async commonCalls({
    pathName = window.location.pathname,
    url = window.location.search,
    getProfile,
    bypass,
    getMetaDataVersion,
    getUserCreditProfile,
    getJobPricingMetaData
  }) {
    const rec_access_token = CookieService.getCookie(
      STORAGE_ITEMS.recAccessToken
    );
    //first auth routes ar checked then profile hard check is checked
    if (AUTH_ROUTES.some(v => pathName.toLowerCase().includes(v)) || bypass) {
      if (!rec_access_token) {
        const urlParams = new URLSearchParams(url);
        const job_id = urlParams.get("job_id") || "";
        const repost = urlParams.get("repost") || "";

        if (Routes.CANDIDATE_LISTING === pathName && job_id) {
          Router.push({ pathname: LOGIN, query: { job_id } });
        } else if (pathName.includes(Routes.LANDING_PAGE)) {
          if (job_id && Boolean(repost)) {
            Router.replace({
              pathname: LOGIN,
              query: { job_id, repost: true }
            });
          }
        } else {
          Router.push({ pathname: LOGIN });
        }
      } else {
        if (getProfile)
          getProfile({
            hardCheck: CHECK_PROFILE.some(v =>
              pathName.toLowerCase().includes(v)
            )
          });
        if (getUserCreditProfile) {
          getUserCreditProfile({
            hardCheck: !IGNORE_CREDIT_PROFILE.some(v =>
              pathName.toLowerCase().includes(v)
            )
          });
        }
        if (getJobPricingMetaData) {
          getJobPricingMetaData();
        }
      }
    }
    if (getMetaDataVersion && rec_access_token) {
      getMetaDataVersion();
    }
  },
  getAccessToken(req) {
    return CookieService.getCookie(STORAGE_ITEMS.recAccessToken, req);
  },
  isAuthenticated(req) {
    return !!this.getAccessToken(STORAGE_ITEMS.recAccessToken, req);
  }
};

export default UserService;
